"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.length = exports.JSONStringify = exports.or = exports.and = exports.newArray = exports.newObject = exports.concatString = exports.concatParagraph = exports.getObjectProperty = exports.flatten = exports.getArrayLength = void 0;
// built-in functions which are not related to runtime context, just pure functions
const getArrayLength = (_context, array) => {
    // if (!array) return 0;
    return array === null || array === void 0 ? void 0 : array.length;
};
exports.getArrayLength = getArrayLength;
/**
 * reduce dimension of array
 * @param context
 * @param array
 * @returns
 */
const flatten = (_context, array) => {
    return array === null || array === void 0 ? void 0 : array.flat();
};
exports.flatten = flatten;
/**
 * get value by json path
 * ({a:{b:1}},['a','b']) => 1
 * if the obj is an array, ([{a:1},{a:2}] ,['a']) => "1,2"
 */
const getObjectProperty = (_context, obj, paths) => {
    const getValue = (obj, paths) => {
        let value = obj;
        for (const path of paths) {
            if (value == null) {
                return null;
            }
            value = value[path];
        }
        return value;
    };
    // [{color: {name:1}},{color: {name:2}}] ,['color'] = > [{name:1},{name:2}]
    if (Array.isArray(obj)) {
        const items = obj.map((item) => getValue(item, paths));
        if (items.every((item) => item == null || ['string', 'number', 'boolean'].includes(typeof item))) {
            return items.join(', ');
        }
        return items;
    }
    return getValue(obj, paths);
};
exports.getObjectProperty = getObjectProperty;
/**
 * concat paragraph with '\n'
 * @param args
 * @returns
 */
const concatParagraph = (...args) => {
    const [, ...paragraphs] = args;
    return paragraphs.join('\n');
};
exports.concatParagraph = concatParagraph;
/**
 * concat string with ''
 */
const concatString = (...args) => {
    const [, ...strings] = args;
    return strings.join('');
};
exports.concatString = concatString;
/**
 * the factory function of object to make a new object
 * [key1,value1,key2,value2,...] => {key1:value1,key2:value2,...}
 */
const newObject = (...args) => {
    const [, ...restArgs] = args;
    // [key1,value1,key2,value2,...] => [[key1,value1],[key2,value2]]
    const keyValuePairs = restArgs.reduce((acc, cur, index) => {
        if (index % 2 === 0) {
            acc.push([cur, restArgs[index + 1]]);
        }
        return acc;
    }, []);
    return Object.fromEntries(keyValuePairs);
};
exports.newObject = newObject;
/**
 * the factory function of array to make a new array
 */
const newArray = (...args) => {
    const [, ...restArgs] = args;
    return new Array(...restArgs);
};
exports.newArray = newArray;
/**
 * logical and
 */
const and = (...args) => {
    const [, ...restArgs] = args;
    // console.log('and', args);
    return restArgs.every(Boolean);
};
exports.and = and;
/**
 * logical or
 */
const or = (...args) => {
    const [, ...restArgs] = args;
    // console.log('or', args);
    return restArgs.some(Boolean);
};
exports.or = or;
/**
 * just json stringify
 * @param args
 * @returns
 */
const JSONStringify = (_context, obj) => {
    // console.log('JSONStringify', obj);
    return JSON.stringify(obj);
};
exports.JSONStringify = JSONStringify;
/**
 * get length of iterable object
 * @param _context
 * @param obj
 */
const length = (_context, obj) => {
    return obj === null || obj === void 0 ? void 0 : obj.length;
};
exports.length = length;
//# sourceMappingURL=base.js.map